/**
 * Custom 404 Not Found Page - ESS Design System
 *
 * A visually appealing error page with:
 * - Large 404 number display
 * - Background image with overlay
 * - Helpful error message
 * - Navigation button to return home
 * - ESS branding and footer
 */

import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { UniversalLink } from '@plone/volto/components';
import { Helmet } from '@plone/volto/helpers';
import { PageSection, ContentWrapper } from 'volto-essvoltocomponents/components/Layout';
import './NotFound.scss'; 

const messages = defineMessages({
  notFoundCode: {
    id: '404',
    defaultMessage: '404',
  },
  notFoundMessage: {
    id: 'The link you clicked may be broken or the page may have been removed.',
    defaultMessage:
      'The link you clicked may be broken or the page may have been removed.',
  },
  visitText: {
    id: 'Visit the',
    defaultMessage: 'Visit the',
  },
  homeLink: {
    id: 'home',
    defaultMessage: 'the Homepage',
  },
  orText: {
    id: 'or',
    defaultMessage: 'or',
  },
  contactLink: {
    id: 'contact us',
    defaultMessage: 'Contact us',
  },
  aboutPage: {
    id: 'about the page.',
    defaultMessage: 'about the problem.',
  },
});

const NotFound = () => {
  const intl = useIntl();

  return (
    <PageSection 
      className="not-found-page" 
      paddingTop="0" 
      paddingBottom="0">
        
      <Helmet title="404" />

        {/* Hero Section with Background Image */}
      <ContentWrapper className="not-found-hero">
        {/* Background image layer with grayscale filter */}
        <div className="not-found-image" aria-hidden="true" />
        {/* Color overlay layer */}
        <div className="not-found-overlay" aria-hidden="true" />
        <div className="not-found-content">
          <h1 className="not-found-code">
            {intl.formatMessage(messages.notFoundCode)}
          </h1>
          <h3 className="not-found-message">
            {intl.formatMessage(messages.notFoundMessage)}
          </h3>
          <p className="not-found-links">
            {intl.formatMessage(messages.visitText)}{' '}
            <UniversalLink href="/" className="not-found-link">
              {intl.formatMessage(messages.homeLink)}
            </UniversalLink>{' '}
            {intl.formatMessage(messages.orText)}{' '}
            <UniversalLink href="/contact-info" className="not-found-link">
              {intl.formatMessage(messages.contactLink)}
            </UniversalLink>{' '}
            {intl.formatMessage(messages.aboutPage)}
          </p>
        </div>
      </ContentWrapper>
    </PageSection>
  );
};

export default NotFound;
